<template>
<div class="update-outlet">
  <row>
    <div class="sl-col-4">
      <div class="sl-form">
        <el-form ref="form" :model="form" label-width="160px" v-loading="fullLoading">
          <el-form-item :label="label.name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item :label="label.place">
            <gmap-autocomplete class="googlePlace" :select-first-on-enter="true" @place_changed="updatePlace" :default-place="googlePlace"></gmap-autocomplete>
          </el-form-item>
          <el-form-item :label="label.country">
            <el-input v-model="form.country" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="label.state">
            <el-input v-model="form.state" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="label.city">
            <el-input v-model="form.city" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="label.lng">
            <el-input v-model="form.lng" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="label.lat">
            <el-input v-model="form.lat" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="label.address1">
            <el-input v-model="form.address1"></el-input>
          </el-form-item>
          <el-form-item :label="label.address2">
            <el-input v-model="form.address2"></el-input>
          </el-form-item>
          <el-form-item :label="label.contact">
            <el-input v-model="form.contact"></el-input>
          </el-form-item>
          <el-form-item :label="label.phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="Upload photos of store">
            <el-col :span="12" :xs="24">
              <el-upload class="upload-photo" action="/client/upload?type=photo" :show-file-list="false" :before-upload="beforePhotoUpload" :on-success="uploadInsidePhotoSuccess" :on-progress="uploadInsideProcess" :on-error="uploadInsidePhotoError" v-loading="insideLoading">
                <p>Shop inside photo</p> <img v-if="insidePhotoUrl !== ''" :src="insidePhotoUrl" class="shop-avatar">
                <i v-else class="el-icon-plus shop-uploader-icon"></i>
              </el-upload>
            </el-col>
            <el-col :span="12" :xs="24">
              <el-upload class="upload-photo" action="/client/upload?type=photo" :show-file-list="false" :before-upload="beforePhotoUpload" :on-success="uploadOutsidePhotoSuccess" :on-progress="uploadOutsideProcess" :on-error="uploadOutsidePhotoError" v-loading="outsideLoading">
                <p>Shop outside photo</p> <img v-if="outsidePhotoUrl !== ''" :src="outsidePhotoUrl" class="shop-avatar">
                <i v-else class="el-icon-plus shop-uploader-icon"></i>
              </el-upload>
            </el-col>
          </el-form-item>
          <el-form-item :label="label.activeTime">
            <el-row class="sl-form-box-week" v-for="item in weeks" :key="item">
              <el-col :span="4" :xs="12" class="week-name"> {{item.name}} </el-col>
              <el-col :span="20" :xs="12">
                <el-input auto-complete="off" v-model="item.value"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="sm-form-btn">
            <el-button type="success" @click="onSubmit" :loading="btnLoading">Save</el-button>
            <el-button type="danger" @click="deleteDialog = true;$ga.event('Button', 'Delete', 'Edit store')">Delete</el-button>
            <router-link tag="el-button" :to="{ name: 'Outlets' }" @click.native="$ga.event('Link', 'Cancel', 'Edit store')">Cancel</router-link>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </row>
  <el-dialog title="Delete store" v-model="deleteDialog" size="tiny">
    <span>Are you sure you want to delete this store ? </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="deleteDialog = false">Cancel</el-button>
      <el-button type="success" @click="deleteOutlet">Confirm</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import api from '../../../api'
const defaultWeeks = [
  {
    name: 'Monday',
    value: ''
  },
  {
    name: 'Tuesday',
    value: ''
  },
  {
    name: 'Wednesday',
    value: ''
  },
  {
    name: 'Thursday',
    value: ''
  },
  {
    name: 'Friday',
    value: ''
  },
  {
    name: 'Saturday',
    value: ''
  },
  {
    name: 'Sunday',
    value: ''
  }
]
export default {
  name: 'update-outlet',
  created() {
    const vm = this
    this.fullLoading = true
    api.FetchOutletById(this.$route.params.id).then(res => {
      if (res.data.code === 200) {
        let form = res.data.data
        vm.insidePhotoUrl = form.insidePics
        vm.outsidePhotoUrl = form.outsidePics
        vm.weeks = JSON.parse(form.activeTime)
        vm.form = form
      }
      vm.fullLoading = false
    })
  },
  computed: {
    checkbox() {
      return [this.$t('Week.sunday'), this.$t('Week.monday'), this.$t('Week.tuesday'), this.$t('Week.wednesday'), this.$t('Week.thursday'), this.$t('Week.friday'), this.$t('Week.saturday')]
    },
    days() {
      return this.checkbox.map(item => ({
        name: item,
        open: this.$t('Date.openTime'),
        close: this.$t('Date.closeTime')
      }))
    },
    label() {
      return {
        name: this.$t('Views.AddNewOutlet.form.name'),
        place: this.$t('Views.AddNewOutlet.form.place'),
        address1: this.$t('Views.AddNewOutlet.form.address1'),
        address2: this.$t('Views.AddNewOutlet.form.address2'),
        contact: this.$t('Views.AddNewOutlet.form.contact'),
        phone: this.$t('Views.AddNewOutlet.form.phone'),
        activeTime: this.$t('Views.AddNewOutlet.form.activeTime'),
        country: this.$t('Views.AddNewOutlet.form.country'),
        state: this.$t('Views.AddNewOutlet.form.state'),
        city: this.$t('Views.AddNewOutlet.form.city'),
        lng: this.$t('Views.AddNewOutlet.form.lng'),
        lat: this.$t('Views.AddNewOutlet.form.lat')
      }
    }
  },
  data() {
    return {
      btnLoading: false,
      insideLoading: false,
      insidePhotoUrl: '',
      outsideLoading: false,
      outsidePhotoUrl: '',
      deleteDialog: false,
      fullLoading: false,
      googlePlace: '',
      weeks: defaultWeeks,
      form: {
        name: '',
        phone: '',
        address1: '',
        city: '',
        state: '',
        country: '',
        contact: '',
        lng: '',
        lat: '',
        maplink: '',
        description: '',
        outsidePics: '',
        insidePics: ''
      }
    }
  },
  methods: {
    beforePhotoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      // const isLt1K = file.size / 1024 > 100
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
      if (!isJPG) {
        this.$message.error('The uploaded image should be with the file format specified to".jpg, .jpeg, .png" extension')
      }
      if (!isLt2M) {
        this.$message.error('The uploaded image should not exceed 2MB!')
      }
      // if (!isLt1K) {
      //   this.$message.error('The uploaded image should not be less than 100KB!')
      // }
      return isLt2M && isJPG
    },
    uploadInsideProcess(event, file, fileList) {
      this.insideLoading = true
    },
    uploadInsidePhotoSuccess(res, file) {
      this.insidePhotoUrl = URL.createObjectURL(file.raw)
      this.form.insidePics = res.data.url
      this.insideLoading = false
    },
    uploadInsidePhotoError(res, file) {
      this.$message.error('Upload failed.')
      this.insideLoading = false
    },
    uploadOutsideProcess(event, file, fileList) {
      this.outsideLoading = true
    },
    uploadOutsidePhotoSuccess(res, file) {
      this.outsidePhotoUrl = URL.createObjectURL(file.raw)
      this.form.outsidePics = res.data.url
      this.outsideLoading = false
    },
    uploadOutsidePhotoError(res, file) {
      this.$message.error('Upload failed.')
      this.outsideLoading = false
    },
    updatePlace(place) {
      let componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name',
        sublocality_level_1: 'long_name'
      }
      this.form.lat = place.geometry.location.lat()
      this.form.lng = place.geometry.location.lng()
      this.form.city = ''
      this.form.state = ''
      this.form.country = ''
      this.form.address1 = place.formatted_address
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0]
        if (componentForm[addressType]) {
          switch (addressType) {
            case 'country':
              this.form.country = place.address_components[i][componentForm[addressType]]
              break
            case 'administrative_area_level_1':
              this.form.state = place.address_components[i][componentForm[addressType]]
              break
            case 'locality':
              this.form.city = place.address_components[i][componentForm[addressType]]
              break
          }
        }
      }
    },
    onSubmit() {
      this.$ga.event('Button', 'Save', 'Edit store')
      const vm = this
      this.btnLoading = true
      let form = JSON.parse(JSON.stringify(this.form))
      form.activeTime = JSON.stringify(this.weeks)
      api.UpdateOutlet(this.$route.params.id, form).then(res => {
        if (res.data.code === 200) {
          vm.successMsg(res)
          vm.$router.go(-1)
        } else {
          vm.errorMsg(res)
        }
        vm.btnLoading = false
      }).catch(error => {
        alert(error)
        vm.btnLoading = false
      })
    },
    deleteOutlet() {
      const vm = this
      this.fullLoading = true
      this.deleteDialog = false
      api.DeleteOutlet(this.$route.params.id).then(res => {
        if (res.data.code === 200) {
          vm.successMsg(res)
          vm.$router.go(-1)
        } else {
          vm.errorMsg(res)
        }
        vm.fullLoading = false
      }).catch(error => {
        alert(error)
      })
    },
    errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      })
    },
    successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      })
    }
  }
}
</script>
<style>
.upload-photo {
  display: inline-block;
  margin: 0 10px;
  width: 300px;
}

.upload-photo .el-button {
  margin: 0 auto;
}

.upload-photo .el-upload__input {
  display: none;
}

.shop-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.shop-avatar {
  width: 300px;
  display: block;
}

.sl-form-box-week {
  padding: 10px 5px;
  border-bottom: none;
}

.sl-form-box-week .week-name {
  font-family: Avenir-Book;
  font-size: 13px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 13px;
  margin-top: 12px;
}

@media only screen and (max-width: 768px) {
  .update-outlet .el-form-item__content {
    margin-left: 0 !important;
  }
  .update-outlet .el-form-item__label {
    text-align: left;
    width: 100% !important;
  }
  .update-outlet .googlePlace {
    border: 1px solid #d7d7d7;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// update-outlet.vue?26ac8d9d